// extracted by mini-css-extract-plugin
export default {"container":"CollapsibleSearch_container__dtbhu","searchInput":"CollapsibleSearch_searchInput__or4MC","searchClose":"CollapsibleSearch_searchClose__+xZ+9"};